/* RESPONSIBLE TEAM: team-frontend-tech */
export default function (tmap) {
  tmap.transition(tmap.hasClass('content-editor__animated-sidebar'), tmap.use('fading-flex-grow'));
}
